module.exports = __webpack_public_path__ + "img/google.2870615c.png";